export default __webpack_public_path__ + "static/media/ai_icon_or.2ca8a1b0.png";